import * as React from "react"
import { connect } from "react-redux"

import { Action } from "@tenforce/toolbox-button-push-react"
import { Checkbox } from "@tenforce/toolbox-selector-react"
import { Header, HeaderRow, Cell } from "@tenforce/toolbox-table-react"
import { Input, FieldItems } from "@tenforce/toolbox-field-react"

import { formatLabel } from "../../../util/Strings"
import { GlobalState } from "../../../store"
import { mapDispatchToProps, DispatchProps } from "../actions"
import { Labels } from "../../../util/Translations"

type StateProps = WorkspaceListPage.WorkspaceListPage

type Props = StateProps & DispatchProps

export class WorkspaceTableHeader extends React.Component<Props> {
    render(): JSX.Element {
        const { Code, ScreenLabel, Active, FilterOnX } = Labels

        const {
            filter: { code, label, isActive: active },
        } = this.props

        return (
            <Header>
                <HeaderRow isCondensed={true}>
                    <Cell>
                        <div className="tw-px-6 tw-truncate">
                            <Action
                                isLabel={true}
                                isDisabled={true}
                                title={Code}
                            >
                                {Code}
                            </Action>
                        </div>
                    </Cell>
                    <Cell>
                        <div className="tw-px-6 tw-truncate">
                            <Action
                                isLabel={true}
                                isDisabled={true}
                                title={ScreenLabel}
                            >
                                {ScreenLabel}
                            </Action>
                        </div>
                    </Cell>
                    <Cell>
                        <div className="tw-px-6 tw-truncate">
                            <Action
                                isLabel={true}
                                isDisabled={true}
                                title={Active}
                            >
                                {Active}
                            </Action>
                        </div>
                    </Cell>
                </HeaderRow>
                <HeaderRow>
                    <Cell>
                        <FieldItems>
                            <Input
                                value={code}
                                onChangedValue={this.filterCode}
                                placeholder={formatLabel(
                                    FilterOnX,
                                    Code,
                                ).toLowerCase()}
                                data-ft-component="codeFilter"
                            />
                        </FieldItems>
                    </Cell>
                    <Cell>
                        <FieldItems>
                            <Input
                                value={label}
                                onChangedValue={this.filterScreenLabel}
                                placeholder={formatLabel(
                                    FilterOnX,
                                    ScreenLabel,
                                ).toLowerCase()}
                                data-ft-component="screenLabelFilter"
                            />
                        </FieldItems>
                    </Cell>
                    <Cell>
                        <FieldItems>
                            <Checkbox
                                data-ft-component="activeFilter"
                                isRequired={true}
                                isChecked={active}
                                onChecked={(): void => {
                                    this.filterActive(true)
                                }}
                                onUnchecked={(): void => {
                                    this.filterActive(false)
                                }}
                            />
                        </FieldItems>
                    </Cell>
                </HeaderRow>
            </Header>
        )
    }

    filterScreenLabel = (screenLabel: string): void => {
        const { filter, filterWorkspaces } = this.props
        filterWorkspaces(filter.code, screenLabel, filter.isActive)
    }

    filterCode = (code: string): void => {
        const { filter, filterWorkspaces } = this.props
        filterWorkspaces(code, filter.label, filter.isActive)
    }

    filterActive = (active: boolean): void => {
        const { filter, filterWorkspaces } = this.props
        filterWorkspaces(filter.code, filter.label, active)
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    ...state.workspaceListPage,
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(WorkspaceTableHeader)
